// Specialty definitions with human-readable labels

export const SPECIALTIES = [
  { label: "Hair", value: "hair" },
  { label: "Nails", value: "nails" },
  { label: "Full Spa", value: "full_spa" },
  { label: "Med Spa", value: "med_spa" },
  { label: "Beauty Salon", value: "beauty_salon" },
  { label: "Lash/Brows", value: "lash_brows" },
  { label: "Wax Bar", value: "wax_bar" },
  { label: "Makeup", value: "makeup" },
  { label: "Aesthetician", value: "aesthetician" },
  { label: "Barber", value: "barber" },
  { label: "Wellness", value: "wellness" },
  { label: "Consultant", value: "consultant" },
  { label: "Photography", value: "photography" },
] as const;

// Map for quick lookup
const specialtyLabelMap: Record<string, string> = SPECIALTIES.reduce(
  (acc, specialty) => {
    acc[specialty.value.toLowerCase()] = specialty.label;
    return acc;
  },
  {} as Record<string, string>
);

/**
 * Convert a specialty value to its human-readable label
 * Falls back to title case if not found in the map
 */
export function getSpecialtyLabel(value: string): string {
  const normalized = value.toLowerCase().trim();
  
  if (specialtyLabelMap[normalized]) {
    return specialtyLabelMap[normalized];
  }
  
  // Fallback: convert snake_case to Title Case
  return value
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}
